import React, { useEffect } from 'react';

function ToastItem({ id, message, type = 'success', onDismiss }) {
  useEffect(() => {
    const timer = setTimeout(() => onDismiss(id), 3500);
    return () => clearTimeout(timer);
  }, [id, onDismiss]);

  return (
    <div className={`ca-toast ca-toast--${type}`} role="status">
      {message}
    </div>
  );
}

export default function ToastContainer({ toasts = [], onDismiss }) {
  if (!toasts.length) return null;
  return (
    <div className="ca-toast-container">
      {toasts.map((toast) => (
        <ToastItem key={toast.id} {...toast} onDismiss={onDismiss} />
      ))}
    </div>
  );
}